import LoadingImage from "../../media/images/loading.svg"
const LoadingPage = ({ widthLoading = 100, heightLoading = 100 }) => {
  return (
    <div><img src={LoadingImage} alt="loading..." width={widthLoading} height={heightLoading}></img></div>
  )
}

export default LoadingPage
